import Wunschliste from 'src/pages/Wunschliste/Wunschliste'
import { getSitePageBuilderStaticProps } from 'src/pageBuilder/sitePageBuilder'

export default Wunschliste

export const getStaticProps = getSitePageBuilderStaticProps
